import * as React from "react";
import { Surface } from "../../../../ui";

// The desktop list in the form's own colours rather than the default grey.
export const ListPaper: React.FC<React.HTMLAttributes<HTMLElement>> = (props) => (
  <Surface {...props} style={{ ...props.style, backgroundColor: "#1f2b3a", border: "1px solid #44576e" }} />
);
